<!-- LIST SKELETON -->
<ion-list *ngIf="type?.show && !type?.card && !type?.head">
  <ion-item lines="none" *ngIf="type?.header">
    <ion-thumbnail slot="start">
      <ion-skeleton-text animated></ion-skeleton-text>
    </ion-thumbnail>
    <ion-label>
      <h3 class="ion-padding-start">
        <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
      </h3>
    </ion-label>
  </ion-item>

  <ion-item class="ion-no-padding">
    <ion-avatar *ngIf="type?.avatar" slot="start">
      <ion-skeleton-text animated></ion-skeleton-text>
    </ion-avatar>
    <ion-label>
      <h3 class="ion-padding-start">
        <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
      </h3>
      <p *ngIf="type?.secondLine" class="ion-padding-start">
        <ion-skeleton-text animated style="width: 65%"></ion-skeleton-text>
      </p>
    </ion-label>
  </ion-item>

  <ion-item class="ion-no-padding">
    <ion-avatar *ngIf="type?.avatar" slot="start">
      <ion-skeleton-text animated></ion-skeleton-text>
    </ion-avatar>
    <ion-label>
      <h3 class="ion-padding-start">
        <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
      </h3>
      <p *ngIf="type?.secondLine" class="ion-padding-start">
        <ion-skeleton-text animated style="width: 65%"></ion-skeleton-text>
      </p>
    </ion-label>
  </ion-item>

  <ion-item class="ion-no-padding">
    <ion-avatar *ngIf="type?.avatar" slot="start">
      <ion-skeleton-text animated></ion-skeleton-text>
    </ion-avatar>
    <ion-label>
      <h3 class="ion-padding-start">
        <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
      </h3>
      <p *ngIf="type?.secondLine" class="ion-padding-start">
        <ion-skeleton-text animated style="width: 65%"></ion-skeleton-text>
      </p>
    </ion-label>
  </ion-item>

  <ion-item class="ion-no-padding">
    <ion-avatar *ngIf="type?.avatar" slot="start">
      <ion-skeleton-text animated></ion-skeleton-text>
    </ion-avatar>
    <ion-label>
      <h3 class="ion-padding-start">
        <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
      </h3>
      <p *ngIf="type?.secondLine" class="ion-padding-start">
        <ion-skeleton-text animated style="width: 65%"></ion-skeleton-text>
      </p>
    </ion-label>
  </ion-item>

  <ion-item class="ion-no-padding">
    <ion-avatar *ngIf="type?.avatar" slot="start">
      <ion-skeleton-text animated></ion-skeleton-text>
    </ion-avatar>
    <ion-label>
      <h3 class="ion-padding-start">
        <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
      </h3>
      <p *ngIf="type?.secondLine" class="ion-padding-start">
        <ion-skeleton-text animated style="width: 65%"></ion-skeleton-text>
      </p>
    </ion-label>
  </ion-item>

  <ion-item class="ion-no-padding">
    <ion-avatar *ngIf="type?.avatar" slot="start">
      <ion-skeleton-text animated></ion-skeleton-text>
    </ion-avatar>
    <ion-label>
      <h3 class="ion-padding-start">
        <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
      </h3>
      <p *ngIf="type?.secondLine" class="ion-padding-start">
        <ion-skeleton-text animated style="width: 65%"></ion-skeleton-text>
      </p>
    </ion-label>
  </ion-item>

  <ion-item class="ion-no-padding">
    <ion-avatar *ngIf="type?.avatar" slot="start">
      <ion-skeleton-text animated></ion-skeleton-text>
    </ion-avatar>
    <ion-label>
      <h3 class="ion-padding-start">
        <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
      </h3>
      <p *ngIf="type?.secondLine" class="ion-padding-start">
        <ion-skeleton-text animated style="width: 65%"></ion-skeleton-text>
      </p>
    </ion-label>
  </ion-item>
</ion-list>



<!-- CARD SKELETON -->
<ng-container *ngIf="type?.show && type?.card">
  <ion-card *ngFor="let item of [].constructor(2)">
    <ion-item lines="full" class="ion-no-padding">
      <ion-grid class="grid-container">
        <ion-row>
          <ion-col size="2" class="ion-no-padding ion-margin-end">
            <ion-thumbnail slot="start">
              <ion-skeleton-text animated></ion-skeleton-text>
            </ion-thumbnail>
          </ion-col>
          <ion-col size="9">
            <ion-grid fixed class="ion-no-padding">
              <ion-row>
                <ion-col size="12" class="ion-no-padding">
                  <ion-card-subtitle>
                    <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                  </ion-card-subtitle>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12" class="ion-no-padding">
                  <ion-card-title>
                    <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
                  </ion-card-title>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>


    <ion-card-content>
      <div class="noti-container">
        <div class="only ion-margin-top">
          <ion-item lines="none">
            <ion-label class="ion-text-wrap">
              <h2>
                <strong>
                  <ion-skeleton-text animated style="width: 95%"></ion-skeleton-text>
                </strong>
              </h2>
              <ion-text color="medium">
                <p class="dates">
                  <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
                </p>
                <p class="dates">
                  <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
                </p>
                <p>
                  <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
                </p>
              </ion-text>
              <br>
              <ion-text color="medium">
                <small>
                  <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
                </small>
              </ion-text>
            </ion-label>
          </ion-item>
        </div>
      </div>
    </ion-card-content>

    <ion-footer class="ion-no-border">
      <ion-toolbar>
        <ion-skeleton-text class="ion-margin-start" animated style="width: 20%"></ion-skeleton-text>
      </ion-toolbar>
    </ion-footer>
  </ion-card>
</ng-container>



<!-- CARD HEADER -->
<ng-container *ngIf="type?.show && type?.head">
  <ion-list>
    <ion-item lines="none">
      <ion-avatar slot="start">
        <ion-skeleton-text animated></ion-skeleton-text>
      </ion-avatar>
      <ion-label>
        <p>
          <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
        </p>
        <p>
          <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
        </p>
      </ion-label>
    </ion-item>
  </ion-list>
  <ion-skeleton-text class="ion-margin-start" animated style="width: 30%"></ion-skeleton-text>
  <ion-skeleton-text class="ion-margin-start" animated style="width: 50%"></ion-skeleton-text>
  <ion-skeleton-text class="ion-margin-start" animated style="width: 60%"></ion-skeleton-text>
  <ion-skeleton-text class="ion-margin-start" animated style="width: 65%"></ion-skeleton-text>
</ng-container>


